import axios from 'axios';

export default function ({state, getters, commit, dispatch}, val) {
  window.app.$confirm('Вы действительно хотите удалить платёж?', `Удаление платежа №${val.Id}`, {
    confirmButtonText: 'Удалить',
    cancelButtonText: 'Отмена',
    type: 'info'
  }).then(() => {
    remove(val.Id)
      .then(() => {
        window.app.$notify.success({
          message: 'Платёж удален',
        });
        commit('list/remove', val);
      })
      .catch(err => {
        if (err.fiscal) {
          window.app
            .$confirm(err.text, 'Возникла ошибка', {
              confirmButtonText: 'Удалить',
              cancelButtonText: 'Отмена',
              type: 'info'
            })
            .then(() => {
              remove(val.Id, {fiscal: true})
                .then(() => {
                  window.app.$notify.success({
                    message: 'Платёж удален',
                  });
                  commit('list/remove', val);
                })
                .catch(err => {
                  window.app.$notify.error(err.text);
                })
            }).catch(e => {
          });
        }
      });
  }).catch(e => {
  });
}

function remove(id, d) {
  return new Promise((resolve, reject) => {
    const fiscal = d ? !!d.fiscal : false;
    axios({
      method: 'post',
      url: '/tourclient/payment/deletePayment?id=' + id,
      data: `id=${id}&UnfastenFiskalDocuments=${fiscal}`,
      requestId: '/tourclient/payment/deletePayment'
    }).then(({data}) => {
      if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
        const err = {text: data.ResultQueryInfo.UserMessages};
        if (data.UnfastenFiskalDocuments) {
          err.fiscal = true;
        }
        reject(err);
      } else {
        resolve(data);
      }
    }).catch(e => {
      reject({text: 'Ошибка при удалении платежа'});
    });
  })
}
